function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages = function SvgMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.47 183.73C5.6 183.69.04 178.13 0 171.26V68.73c.04-14.23 11.57-25.76 25.8-25.8h121.67c14.26 0 25.83 11.54 25.87 25.8v68.33c0 14.26-11.54 25.83-25.8 25.87H46.07c-1.15 0-2.27.38-3.2 1.07L20 181.27a12.6 12.6 0 0 1-7.53 2.47zM25.8 56.27c-6.87.04-12.43 5.6-12.47 12.47v100.87l21.53-16.27c3.24-2.41 7.16-3.71 11.2-3.73h101.4c6.92 0 12.53-5.61 12.53-12.53V68.75c-.04-6.87-5.6-12.43-12.47-12.47z",
    style: {
      fill: "#1b053a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.93,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "#1b053a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.07,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "#1b053a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4,
    cy: 103.53,
    r: 6.67,
    style: {
      fill: "#1b053a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33 116.27c-3.68 0-6.67-2.98-6.67-6.67V42.07c-.04-6.87-5.6-12.43-12.47-12.47H40c-3.68 0-6.67-2.98-6.67-6.67s2.98-6.67 6.67-6.67h134.2c14.23.04 25.76 11.57 25.8 25.8v67.53c0 3.68-2.98 6.67-6.67 6.67z",
    style: {
      fill: "#1b053a"
    }
  }));
};
export default SvgMessages;